import {OCCACTIMODELS_EMPTY, useOccActimodelMutations} from "../../api/occactimodelsapi";
import React, {useCallback} from "react";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {CustomEditorFilledCheck, FormControlCustom} from "../controls/FormControls";
import {pdf, PDFViewer} from "@react-pdf/renderer";
import {useFileMutations} from "../../api/fileapi";
import {useEmailMutations} from "../../api/emailapi";
import {Bounce, toast} from "react-toastify";
import {OccActiPdf} from "../formpdf/OccActiPdf";
import {minioBaseUrl} from "../../data/defaultConfig";
import {LabelWithInput} from "../grouping/LabelWithInput";

export function OccActimodelForm(props) {
    const {itemEditing, onItemEditingChanged, onOpenChanged} = props;
    const {createOccActimodel, editOccActimodel} = useOccActimodelMutations();
    const initialObjectInintializer = useCallback(() => itemEditing ? itemEditing : OCCACTIMODELS_EMPTY, [])
    const {onChange, tempObject, onEditorChange} = useForm(initialObjectInintializer);
    const {uploadFile} = useFileMutations();
    const {createFormEmail} = useEmailMutations();
    const notify = (message, type) => {
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: type,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    async function handleCreate(event) {
        event.preventDefault();
        const response = await createOccActimodel({
            ...tempObject,
            datumDoorgegeven: (new Date().toISOString()),
            datumActiv: tempObject.datumActiv ? tempObject.datumActiv + 'T00:00:00' : new Date().toISOString
        });
        if (response) {
            notify('Occasionele activiteit is verzonden.', 'success');
            const blob = await pdf(OccActiPdf({occActiTempObject: tempObject})).toBlob();
            const pdfFile = new File([blob], `occActi-${new Date().toISOString().substring(0, 10)}${new Date().getMinutes()}${new Date().getMilliseconds()}.pdf`);
            const uploadFileResult = await uploadFile({file: pdfFile});
            if (uploadFileResult) {
                const newEmail = {
                    title: "VBFlw, Nieuw Occasionele activiteit formulier ingevuld",
                    emailto: '',
                    emailfrom: "administratie@vbflw.be",
                    description: `
                    <p>Er is een Occasionele activiteit formulier ingevuld.</p>
                    <a href="${minioBaseUrl + uploadFileResult.url}">Click hier voor de pdf te downloaden</a>
                    `,
                    attachment: uploadFileResult.id
                };
                const emailResult = await createFormEmail(newEmail);
                if (emailResult) window.location.reload();
            }
        }
        if (!response) notify('Fout bij het verzenden. Probeer het later nog eens.', 'error');
    }

    async function handleEdit(e) {
        const result = await editOccActimodel(tempObject);
        if (result) {
            onItemEditingChanged(undefined);
            onOpenChanged(false);
        }
    }

    const formComplete =
        tempObject.provincie &&
        tempObject.sector &&
        tempObject.club &&
        tempObject.stamNr &&
        tempObject.secretarisNaam &&
        tempObject.secretarisVoornaam &&
        tempObject.secretarisStraat &&
        tempObject.secretarisNr &&
        tempObject.secretarisPostnr &&
        tempObject.secretarisGemeente &&
        tempObject.secretarisTelGsmFax &&
        tempObject.verantNaam &&
        tempObject.verantVoornaam &&
        tempObject.verantStraat &&
        tempObject.verantNr &&
        tempObject.verantPostnr &&
        tempObject.verantGemeente &&
        tempObject.verantTelGsmFax &&
        tempObject.datumActiv &&
        tempObject.locatieActiv &&
        tempObject.naamActiv &&
        tempObject.adresActiv &&
        tempObject.telGsmFaxActiv &&
        tempObject.omschrijvingActiv;
    return <Form>
        <Section>
            <Col xs={6}>
                <FormControlCustom title={'Provincie*'} value={tempObject.provincie} filled={tempObject.provincie}
                                   onChange={e => onChange(e, 'provincie')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Sector*'} value={tempObject.sector} filled={tempObject.sector}
                                   onChange={e => onChange(e, 'sector')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Club*'} value={tempObject.club} filled={tempObject.club} onChange={e => onChange(e, 'club')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Stamnr*'} value={tempObject.stamNr} filled={tempObject.stamNr} onChange={e => onChange(e, 'stamNr')}/>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={2}>
                Secretaris
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={6}>
                        <FormControlCustom title={'Naam*'} value={tempObject.secretarisNaam} filled={tempObject.secretarisNaam}
                                           onChange={e => onChange(e, 'secretarisNaam')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Voornaam*'} value={tempObject.secretarisVoornaam} filled={tempObject.secretarisVoornaam}
                                           onChange={e => onChange(e, 'secretarisVoornaam')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Straat*'} value={tempObject.secretarisStraat} filled={tempObject.secretarisStraat}
                                           onChange={e => onChange(e, 'secretarisStraat')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Nr*'} value={tempObject.secretarisNr} filled={tempObject.secretarisNr}
                                           onChange={e => onChange(e, 'secretarisNr')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Postnr*'} value={tempObject.secretarisPostnr} filled={tempObject.secretarisPostnr}
                                           onChange={e => onChange(e, 'secretarisPostnr')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Gemeente*'} value={tempObject.secretarisGemeente} filled={tempObject.secretarisGemeente}
                                           onChange={e => onChange(e, 'secretarisGemeente')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Tel/Gsm/Fax*'} value={tempObject.secretarisTelGsmFax} filled={tempObject.secretarisTelGsmFax}
                                           onChange={e => onChange(e, 'secretarisTelGsmFax')}/>
                    </Col>
                </Section>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={2}>
                Aanwezige verantwoordelijke
            </Col>
            <Col xs={10}>
                <Section>
                    <Col xs={6}>
                        <FormControlCustom title={'Naam*'} value={tempObject.verantNaam} filled={tempObject.verantNaam}
                                           onChange={e => onChange(e, 'verantNaam')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Voornaam*'} value={tempObject.verantVoornaam} filled={tempObject.verantVoornaam}
                                           onChange={e => onChange(e, 'verantVoornaam')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Straat*'} value={tempObject.verantStraat} filled={tempObject.verantStraat}
                                           onChange={e => onChange(e, 'verantStraat')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Nr*'} value={tempObject.verantNr} filled={tempObject.verantNr}
                                           onChange={e => onChange(e, 'verantNr')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Postnr*'} value={tempObject.verantPostnr} filled={tempObject.verantPostnr}
                                           onChange={e => onChange(e, 'verantPostnr')}/>
                    </Col>
                    <Col xs={6}>
                        <FormControlCustom title={'Gemeente*'} value={tempObject.verantGemeente} filled={tempObject.verantGemeente}
                                           onChange={e => onChange(e, 'verantGemeente')}/>
                    </Col>
                    <Col xs={12}>
                        <FormControlCustom title={'Tel/Gsm/Fax*'} value={tempObject.verantTelGsmFax} filled={tempObject.verantTelGsmFax}
                                           onChange={e => onChange(e, 'verantTelGsmFax')}/>
                    </Col>
                </Section>
            </Col>
        </Section>
        <hr/>
        <Section>
            <Col xs={6}>
                <FormControlCustom title={'Datum activiteit*'} value={tempObject.datumActiv} filled={tempObject.datumActiv} type={'date'}
                                   onChange={e => onChange(e, 'datumActiv')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Locatie*'} value={tempObject.locatieActiv} filled={tempObject.locatieActiv}
                                   onChange={e => onChange(e, 'locatieActiv')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Uur van de activiteit*'} value={tempObject.naamActiv} filled={tempObject.naamActiv}
                                   onChange={e => onChange(e, 'naamActiv')}/>
            </Col>
            <Col xs={6}>
                <FormControlCustom title={'Adres Activiteit*'} value={tempObject.adresActiv} filled={tempObject.adresActiv}
                                   onChange={e => onChange(e, 'adresActiv')}/>
            </Col>
            <Col xs={12}>
                <FormControlCustom title={'Tel/Gsm/Fax activiteit*'} value={tempObject.telGsmFaxActiv} filled={tempObject.telGsmFaxActiv}
                                   onChange={e => onChange(e, 'telGsmFaxActiv')}/>
            </Col>
        </Section>
        <Section>

            <CustomEditorFilledCheck title={'Omschrijving*'} initText={tempObject.omschrijvingActiv} filled={tempObject.omschrijvingActiv}
                                     fieldName={'omschrijvingActiv'} onEditorChange={onEditorChange}/>
            {itemEditing ? <Col xs={6} className={'p-1'}>
                <Section>
                    <Col xs={12}>
                        <FormLabel htmlFor={'vzwjn'}>Verwerkt? </FormLabel>
                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={'ja'}> <FormCheck id={'verwerktja'} defaultChecked={tempObject.verwerkt}
                                                                 name={'verwerkt'} value={"true"} type={'radio'}
                                                                 onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>

                    </Col>
                    <Col xs={'auto me-2'}>
                        <LabelWithInput title={'nee'}> <FormCheck id={'verwerktnee'}
                                                                  defaultChecked={!tempObject.verwerkt}
                                                                  name={'verwerkt'}
                                                                  value={"false"} type={'radio'}
                                                                  onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>
                    </Col>
                </Section>
            </Col> : ''}
        </Section>
        <Section>
            <Col xs={12} className={'text-end'}>
                <Button disabled={!formComplete} type={'button'}
                        onClick={e => itemEditing ? handleEdit(e) : handleCreate(e)}>{!formComplete ? 'Nog niet alle verplichte * velden zijn ingevuld!' : 'Submit'}</Button>
            </Col>
        </Section>

    </Form>

}